// extracted by mini-css-extract-plugin
export default {"row":"CropsRowRenderer_row__aWG9v"};